import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createForgotPasswordSchema(t: TFunction) {
  return z.object({
    email: z
      .string()
      .min(1, t('validation.email_required'))
      .email(t('validation.email_invalid')),
  });
}

export type ForgotPasswordFormValues = z.infer<ReturnType<typeof createForgotPasswordSchema>>;
